export enum InvoicingLanguage {
    FI = 'fi',
    EN = 'en',
}
